import Restaurant from "./pages/Restaurant";
import Menu from "./pages/Menu";
import Main from "./pages/Main";
import Reservations from "./pages/Reservations";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Admin from "./pages/Admin/";

import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

function App() {
  return (

    <Router>
      <Switch>
      <Route path="/menu/:local_id/mesa/:mesa">
          <Menu/>
        </Route>

        <Route path="/menu/:local_id">
          <Menu/>
        </Route>

        <Route path='/reservaciones/:local_id'>
          <Reservations/>
        </Route>

        <Route path='/checkout/:local_id'>
          <Checkout/>
        </Route>

        <Route path='/login'>
          <Login/>
        </Route>

        <Route path='/admin/:local_id'>
          <Admin/>
        </Route>

        <Route path="/:local_id">
          <Restaurant/>
        </Route>

        <Route path="/">
          <Main/>
        </Route>

      </Switch>
    </Router>
  );
}

export default App;
